module.exports = __webpack_public_path__ + "img/D5-1-1-img01-en.26823740.jpg";